export default {
    "Overview": "Aperçu",
    "Energy": "Énergie",
    "KPI": "KPI",
    "Notification Breakdown": "Détail des notifications",
    "Notification Summary": "Résumé des notifications",
    "Monthly Summary": "Résumé mensuel",
    "Plots": "Graphiques",
    "Time Series Plots": "Graphiques de séries temporelles",
    "Equipment Plots": "Graphiques d’équipement",
    "Facet Plots": "Graphiques par facettes",
    "Scatter Plots": "Nuages de points",
    "Fault Detection": "Détection de pannes",
    "Fault Detection (Machine Learning)": "Détection de pannes (apprentissage automatique)",
    "Fault Summary": "Résumé des pannes",
    "Diagnostics": "Diagnostic",
    "Cooling Load": "Charge de refroidissement",
    "CHW Supply Temperature": "Température d’alimentation en eau glacée (CHW)",
    "CHW Return Temperature": "Température de retour en eau glacée (CHW)",
    "Chiller Performance": "Performance du refroidisseur",
    "Cooling Performance": "Performance du refroidissement",
    "Working Hours": "Heures de fonctionnement",
    "Chiller Overview": "Aperçu du refroidisseur",
    "Config": "Configuration",
    "Equipments": "Équipements",
    "Facilities": "Installations",
    "Anomaly Descriptions": "Descriptions d’anomalies",
    "Points": "Points",
    "Parameter": "Paramètre",
    "Settings": "Paramètres",
    "Report": "Rapport",
    "Rules": "Règles",
    "Export Data": "Exporter les données",
    "Custom Views": "Vues personnalisées",
    "Dates": "Dates",
    "Equipment Servicing Schedule": "Calendrier de maintenance de l’équipement",
    "Menu items": "Éléments du menu",
    "Maintenance Record": "Enregistrement de maintenance",
    "Terms of Service": "Conditions d’utilisation",
    "Logged in as": "Connecté en tant que",
    "Account Settings": "Paramètres du compte",
    "Logout": "Déconnexion",
    "Loading Points List": "Chargement de la liste des points",
    "Save": "Enregistrer",
    "Cancel": "Annuler",
    "User Name": "Nom d’utilisateur",
    "Email": "Adresse e-mail",
    "Change password?": "Changer de mot de passe ?",
    "Issue": "Problème",
    "Equipment": "Équipement",
    "Equipment Type": "Type d’équipement",
    "Floor": "Étage",
    "Start Date": "Date de début",
    "End Date": "Date de fin",
    "ID": "ID",
    "Actions": "Actions",
    "Energy Consumption VS Baseline": "Consommation d’énergie VS référence",
    "Not including all equipment in the building": "N’inclut pas tout l’équipement du bâtiment",
    "Hour": "Heure",
    "Fault severity": "Gravité de la panne",
    "Fault breakdown": "Détail des pannes",
    "Room Temperature": "Température de la pièce",
    "AHU Run Time (hr)": "Temps de fonctionnement de l’UTA (h)",
    "Chiller Run Time (hr)": "Temps de fonctionnement du refroidisseur (h)",
    "User": "Utilisateur",
    "test": "test",
    "Chillers": "Refroidisseurs",
    "Pumps": "Pompes",
    "VAVs": "VAV (volume d’air variable)",
    "AHUs": "UTA (unités de traitement d’air)",
    "Cooling Towers": "Tours de refroidissement",
    "Baseline": "Référence",
    "Power (Chiller only) ": "Puissance (uniquement pour le refroidisseur)",
    "Time": "Temps",
    "Power Consumption": "Consommation électrique",
    "Energy Consumption Profile": "Profil de consommation d’énergie",
    "Time (hourly)": "Temps (horaire)",
    "Energy Consumption Breakdown": "Répartition de la consommation d’énergie",
    "Air conditioning - Air side": "Climatisation – Côté air",
    "Power Heat Map": "Carte thermique de la puissance",
    "Chiller": "Refroidisseur",
    "Chiller COP": "COP du refroidisseur",
    "AHU": "UTA",
    "Annualized BPI": "BPI annuel (indice de performance du bâtiment)",
    "Occupant Comfort Index": "Indice de confort des occupants",
    "Maintenance Fault Index": "Indice de panne/de maintenance",
    "Energy Saving": "Économies d’énergie",
    "Severity": "Gravité",
    "Modify Logic and Severity": "Modifier la logique et la gravité",
    "Mark as Useful": "Marquer comme utile",
    "Topic": "Sujet",
    "Download": "Télécharger",
    "Alerts": "Alertes",
    "Recommended Actions": "Actions recommandées",
    "Acknowledged": "Reconnu",
    "Acknowledged by": "Reconnu par",
    "Last acknowledged date": "Dernière date de reconnaissance",
    "Acknowledge": "Reconnaître",
    "Un-Acknowledge": "Annuler la reconnaissance",
    "Occured between": "S’est produit entre",
    "and": "et",
    "Add Maintenance Record": "Ajouter un enregistrement de maintenance",
    "View Chart": "Afficher le graphique",
    "View Chart in New Tab": "Afficher le graphique dans un nouvel onglet",
    "Add maintenance record": "Ajouter un enregistrement de maintenance",
    "View chart": "Afficher le graphique",
    "View maintenanace records for this period": "Afficher les enregistrements de maintenance pour cette période",
    "Equipment Health Score": "Indice de santé de l’équipement",
    "Export as PDF": "Exporter en PDF",
    "Create Maintenance Record": "Créer un enregistrement de maintenance",
    "Create maintenance record": "Créer un enregistrement de maintenance",
    "Maintenance Records": "Enregistrements de maintenance",
    "Show All Maintenance Records": "Afficher tous les enregistrements de maintenance",
    "Jump to Equipment Trend Plots": "Aller aux graphiques de tendance de l’équipement",
    "Supervised Detection": "Détection supervisée",
    "Algorithm Detection": "Détection algorithmique",
    "Health": "Santé",
    "Sensor": "Capteur",
    "Supervised Detection Scores (Higher indicates error)": "Scores de détection supervisée (plus haut indique une anomalie)",
    "Anomaly Detection Scores (Higher indicates error)": "Scores de détection d’anomalie (plus haut indique une anomalie)",
    "Unack": "Non reconnu",
    "Medium": "Moyen",
    "High": "Élevé",
    "30 days": "30 jours",
    "90 days": "90 jours",
    "1 year": "1 an",
    "all": "tout",
    "Keyword filter": "Filtre par mot-clé",
    "Critical/High/Medium": "Critique/Élevé/Moyen",
    "Low": "Faible",
    "Anomaly": "Anomalie",
    "Relevant variables": "Variables pertinentes",
    "Fault Analysis": "Analyse de panne",
    "Export all as PDF": "Tout exporter en PDF",
    "Rule evaluation": "Évaluation des règles",
    "Change": "Changer",
    "Analysis": "Analyse",
    "Energy Consumption Comparison Summary": "Résumé de comparaison de consommation d’énergie",
    "Outdoor Temperature": "Température extérieure",
    "Fault Severity": "Gravité de la panne",
    "Chiller Running Hours": "Heures de fonctionnement du refroidisseur",
    "Fault Breakdown": "Répartition des pannes",
    "Weather": "Météo",
    "Baseline Weather": "Météo de référence",
    "Print": "Imprimer",
    "Energy/Faults": "Énergie/Pannes",
    "Chiller Plant Performance": "Performance de l’installation de refroidissement",
    "Current": "Actuel",
    "YTD this year": "Depuis le début de l’année en cours",
    "YTD last year": "Depuis le début de l’année précédente",
    "FDD Costs": "Coûts FDD (diagnostic de panne)",
    "Unacknowledged": "Non reconnu",
    "Total": "Total",
    "Plant COP (chiller only)": "COP de l’installation (refroidisseur uniquement)",
    "Time ": "Temps ",
    "COP": "COP",
    "Chiller COP vs Cooling Load": "COP du refroidisseur vs charge de refroidissement",
    "Energy Consumption": "Consommation d’énergie",
    "Plant COP (chiller only) vs Outdoor Temperature": "COP de l’installation (refroidisseur uniquement) vs température extérieure",
    "Header Main Supply Temperature vs Outdoor Temperature": "Température principale d’alimentation vs température extérieure",
    "Outdoor Temp": "Temp. extérieure",
    "Header Main Supply Temperature": "Température principale d’alimentation",
    "Chilled Water Delta Temp": "Delta de température de l’eau glacée",
    "Temperature Diff": "Différence de température",
    "Chiller Plant": "Installation de refroidissement",
    "Runtime": "Temps de fonctionnement",
    "Fault": "Panne",
    "No fault detected from": "Aucune panne détectée de",
    "to": "à",
    "View anomalies for": "Afficher les anomalies pour",
    "View notifications for": "Afficher les notifications pour",
    "View equipment summary for": "Afficher le résumé de l’équipement pour",
    "FDD Faults": "Pannes FDD",
    "Recommended actions": "Actions recommandées",
    "Most Expensive Faults. Total Cost": "Pannes les plus coûteuses. Coût total",
    "Faults With Highest Duration Of Occurrence (hr)": "Pannes avec la plus longue durée d’occurrence (h)",
    "Date From": "Date de début",
    "Date To": "Date de fin",
    "Fixed": "Réparé",
    "Assigned to": "Assigné à",
    "Assigned by": "Assigné par",
    "Assigned date": "Date d’assignation",
    "Assigned to me": "Assigné à moi",
    "Assigned by me": "Assigné par moi",
    "View Points when Chiller is On": "Voir les points lorsque le refroidisseur est en marche",
    "Latest Cooling Load Forecast": "Dernière prévision de charge de refroidissement",
    "Forecast": "Prévision",
    "Chiller Staging Profile": "Profil d’échelonnement du refroidisseur",
    "Export charts as PDF": "Exporter les graphiques en PDF",
    "PMV": "PMV (vote moyen prévisionnel)",
    "View this rule on other equipments in": "Afficher cette règle sur d’autres équipements dans",
    "View faults for": "Afficher les pannes pour",
    "Date Range": "Plage de dates",
    "Today": "Aujourd’hui",
    "Yesterday": "Hier",
    "Last 30 Days": "30 derniers jours",
    "Fault Comparison": "Comparaison des pannes",
    "Rule": "Règle",
    "No matching equipments": "Aucun équipement correspondant",
    "No Fault detected for this range and equipment": "Aucune panne détectée pour cette plage et cet équipement",
    "No Relevant Notifications": "Aucune notification pertinente",
    "Equipment Name": "Nom de l’équipement",
    "Search": "Rechercher",
    "Refresh": "Rafraîchir",
    "Active (hr)": "Actif (h)",
    "Cost": "Coût",
    "Active (as % of on time)": "Actif (en % du temps de fonctionnement)",
    "Last Detected": "Dernière détection",
    "Issues Diagnostics for": "Diagnostic des problèmes pour",
    "Other Readings": "Autres lectures",
    "Anomaly Machine Learning Models": "Modèles d’apprentissage automatique pour les anomalies",
    "Anomaly machine learning models establish normal operation profile using historical data.": "Les modèles d’apprentissage automatique pour les anomalies établissent un profil de fonctionnement normal à partir de données historiques.",
    "Machine Learning model is data driven and can handle non-linear boundaries and high dimensionality.": "Le modèle d’apprentissage automatique est axé sur les données et peut gérer des frontières non linéaires ainsi qu’une forte dimensionnalité.",
    "Show Mine Only": "Afficher seulement les miens",
    "Bulk Upload Excel": "Téléchargement de masse Excel",
    "Add Record": "Ajouter un enregistrement",
    "Notifications": "Notifications",
    "Show Unack Notifications Only": "Afficher uniquement les notifications non reconnues",
    "Add Plots": "Ajouter des graphiques",
    "Filter": "Filtrer",
    "Drag to Add Lines to Plot": "Faites glisser pour ajouter des courbes au graphique",
    "Password": "Mot de passe",
    "Login": "Connexion",
    "Set Server URL": "Définir l’URL du serveur",
    "Variable X": "Variable X",
    "Variable Y": "Variable Y",
    "Facet Groups": "Groupes de facettes",
    "Variable Facet": "Facette de variable",
    "Chiller Optimisation Example": "Exemple d’optimisation du refroidisseur",
    "Using PSO optimisation algorithm, expected COP under different operating parameters at particular cooling loads can be found as depicted by the red dots.  The historical consumption is shown as blue dots below.  By choosing optimal temperature setpoints and sequencing, energy saving can be achieved by picking the set of parameters achieving highest COP.": "En utilisant l’algorithme d’optimisation PSO, on peut déterminer le COP attendu sous différents paramètres de fonctionnement et à divers niveaux de charge de refroidissement, comme indiqué par les points rouges. La consommation historique est illustrée par les points bleus ci-dessous. En choisissant les consignes de température optimales et l’ordre de mise en marche, on peut réaliser des économies d’énergie en sélectionnant l’ensemble de paramètres donnant le COP le plus élevé.",
    "95% Confidence Interval": "Intervalle de confiance à 95 %",
    "Actual observed value": "Valeur observée réelle",
    "Fitted value": "Valeur ajustée",
    "Expected value": "Valeur attendue",
    "Upload File": "Téléverser un fichier",
    "Remove existing rules": "Supprimer les règles existantes",
    "Upload": "Téléverser",
    "Upload Excel": "Téléverser un Excel",
    "Maintenance Records Creation": "Création d’enregistrements de maintenance",
    "Reference URL": "URL de référence",
    "Fixed?": "Réparé ?",
    "Normal maintenance record": "Enregistrement de maintenance normal",
    "Comment": "Commentaire",
    "Add": "Ajouter",
    "View Reference Link": "Afficher le lien de référence",
    "View Reference Link in New Tab": "Afficher le lien de référence dans un nouvel onglet",
    "Optimization Saving": "Économies grâce à l’optimisation",
    "Digital Twins": "Jumeaux numériques",
    "Chiller Efficiency Surface": "Surface d’efficacité du refroidisseur",
    "Optimization Saving Calculation": "Calcul d’économies d’optimisation",
    "Optimization is based on temperature reset of the chilled water supply temperature as well as optimal staging of chillers and pumps.": "L’optimisation repose sur la réinitialisation de la température de l’eau glacée ainsi que sur l’échelonnement optimal des refroidisseurs et des pompes.",
    "Chillers' efficiency would also differ under different loading percentage, environmental conditions and external factors. This provides opportunity to improve the staging of chillers. Further optimization is possible due to unfulfilled temperature reset and differential pressure reset potential. Less cooling capacity buffer would be required if air-side sensors indicates that room temperature is optimal.": "L’efficacité des refroidisseurs varie également selon le pourcentage de charge, les conditions environnementales et d’autres facteurs externes. Cela offre une opportunité d’améliorer l’échelonnement des refroidisseurs. Une optimisation supplémentaire est possible grâce au potentiel non exploité de réinitialisation de température et de pression différentielle. Une moindre réserve de capacité de refroidissement serait nécessaire si les capteurs côté air indiquent que la température de la pièce est optimale.",
    "Total Cooling Load": "Charge totale de refroidissement",
    "Duration": "Durée",
    "Projected Energy Consumption": "Consommation d’énergie projetée",
    "Saving": "Économie",
    "Cost Savings": "Économies de coûts",
    "Diagnostic Plots": "Graphiques de diagnostic",
    "Power consumption forecast based on setpoint such as evaporator supply temperature and external environment factors such as condenser water temperature and outdoor air temperature.": "Prévision de la consommation électrique basée sur les consignes (p. ex. température d’alimentation de l’évaporateur) et sur des facteurs environnementaux externes (p. ex. température de l’eau du condenseur et température extérieure).",
    "The charts reveal the relationship between the prediction and actual consumption.  A chart showing a strong correlation indicates a good model.": "Les graphiques révèlent la relation entre la prévision et la consommation réelle. Un graphique présentant une forte corrélation indique un bon modèle.",
    "Chiller efficiency is greatly influenced by the loading of the chiller and external factor such as condenser water temperature.": "L’efficacité du refroidisseur est fortement influencée par sa charge et par des facteurs externes comme la température de l’eau du condenseur.",
    "The 3D scatter plots of the power consumption reveals a efficiency surface where chiller optimization can be performed.": "Les nuages de points 3D de la consommation révèlent une surface d’efficacité permettant une optimisation du refroidisseur.",
    "Chilled Water Supply Temp (actual)": "Température d’alimentation en eau glacée (réelle)",
    "Plant COP": "COP de l’installation",
    "Plant Power": "Puissance totale de l’installation",
    "Chilled Water Supply Temp (optimized)": "Température d’alimentation en eau glacée (optimisée)",
    "Original COP": "COP initial",
    "Optimized COP": "COP optimisé",
    "Original Power": "Puissance initiale",
    "Optimized Power": "Puissance optimisée",
    "Menu Configuration": "Configuration du menu",
    "Air Side Equipment": "Équipement côté air",
    "Overall Power Status": "État global de la puissance",
    "Condensing Water Pump": "Pompe à eau de condensation",
    "Power Analyzer": "Analyseur de puissance",
    "Chilled Water Pump": "Pompe à eau glacée",
    "Cooling Tower": "Tour de refroidissement",
    "CHW Header": "Collecteur d’eau glacée (CHW)",
    "Heatmaps": "Cartes thermiques",
    "PAU Breakdown": "Détail UTA d’air frais (PAU)",
    "PAU CD_Tem & VFD_Feedback": "Température d’alimentation PAU & retour VFD",
    "AHU CD_Tem & RT_Tem & VFD_Feedback": "Température d’alimentation UTA & temp. retour & retour VFD",
    "AHU CD_Tem & RT_Tem & Valve_Control": "Température d’alimentation UTA & temp. retour & contrôle de vanne",
    "PAU CD_Tem & Valve_Control": "Température d’alimentation PAU & contrôle de vanne",
    "AHU RT_Tem vs. VFD_Feedback": "Température de retour UTA vs retour VFD",
    "PAU CD_Tem vs. Valve Control": "Température d’alimentation PAU vs contrôle de vanne",
    "AHU CD_Tem vs. Valve Control": "Température d’alimentation UTA vs contrôle de vanne",
    "AHU Breakdown": "Détail UTA",
    "AHU CO2": "CO₂ UTA",
    "PAU CO2": "CO₂ PAU",
    "Environmental Performance": "Performance environnementale",
    "Running Status - CHWP & WCC": "État de fonctionnement - Pompe à eau glacée & refroidisseur eau/eau",
    "Equipment Power Consumption": "Consommation électrique de l’équipement",
    "Running Status - CHWP-A & ACC": "État de fonctionnement - Pompe à eau glacée-A & refroidisseur air/eau",
    "Running Status - WCC & CWP & CT": "État de fonctionnement - Refroidisseur eau/eau & pompe à eau de refroidissement & tour de refroidissement",
    "Running Status - AHU & PAU": "État de fonctionnement - UTA & PAU",
    "Running Status vs. Schedule": "État de fonctionnement vs. planning",
    "CDW Delta T vs Mean CDWP Power": "Delta T eau de refroidissement vs puissance moyenne pompe eau de refroidissement",
    "WCC Cond Entering & Leaving Temperature": "Température d’entrée & de sortie du condenseur (refroidisseur eau/eau)",
    "WCC CHWR_Temp & CHWS_Temp": "Temp. de retour en eau glacée & temp. d’alimentation (refroidisseur eau/eau)",
    "WCC Cooling Load Overview": "Aperçu de la charge de refroidissement pour refroidisseur eau/eau",
    "WCC COP": "COP du refroidisseur eau/eau",
    "COP vs Cooling Loads ": "COP vs charge de refroidissement",
    "POA Power Factor": "Facteur de puissance (analyseur de puissance)",
    "POA Hz": "Fréquence (analyseur de puissance)",
    "POA Voltage": "Tension (analyseur de puissance)",
    "POA Power": "Puissance (analyseur de puissance)",
    "CHWP VSD_Speed_Feedback": "Retour de vitesse VSD pompe à eau glacée",
    "CT Speed_Feedback": "Retour de vitesse tour de refroidissement",
    "CT Wetbulb Approach": "Approche du bulbe humide (tour de refroidissement)",
    "CT Breakdown": "Détail de la tour de refroidissement",
    "CT Speed Feedback & Running Status": "Retour de vitesse & état de fonctionnement (tour de refroidissement)",
    "CT Entering & Leaving Temperature": "Température d’entrée & de sortie (tour de refroidissement)",
    "AHU PAU Temperatures and Setpoints": "Températures & consignes pour UTA et PAU",
    "CHW DP vs OAT": "DP eau glacée vs température extérieure",
    "Second Floor Mean Air Temperature": "Température moyenne du deuxième étage",
    "First Floor Air Temperature": "Température du premier étage",
    "Reset": "Réinitialiser",
    "Upload Point List": "Téléverser la liste de points",
    "Upload Point List CSV": "Téléverser la liste de points CSV",
    "Point List upload": "Téléverser la liste de capteurs",
    "Upload data for": "Téléverser des données pour",
    "Upload CSV data for": "Téléverser un fichier CSV pour",
    "Add Equipment": "Ajouter un équipement",
    "Add Point": "Ajouter un point",
    "Edit Equipment": "Modifier l’équipement",
    "Delete Equipment": "Supprimer l’équipement",
    "Upload Data": "Téléverser des données",
    "Edit Point": "Modifier le point",
    "Delete Point": "Supprimer le point",
    "Algorithmic Fault Detection": "Détection algorithmique de panne",
    "Automated Debug": "Débogage automatisé",
    "Custom View Configuration Issues": "Problèmes de configuration de vue personnalisée",
    "Chart Builder": "Générateur de graphiques",
    "Are you sure you want to delete this item?": "Êtes-vous sûr de vouloir supprimer cet élément ?",
    "Notes": "Notes",
    "Sensor Name": "Nom du capteur",
    "Sensor Name Abbr": "Nom abrégé du capteur",
    "Faulty": "Défectueux",
    "Upstream ID": "ID en amont",
    "Weight": "Poids",
    "Are you sure you want to delete this sensor?": "Êtes-vous sûr de vouloir supprimer ce capteur ?",
    "Are you sure you want to delete this equipment?": "Êtes-vous sûr de vouloir supprimer cet équipement ?",
    "Add Query": "Ajouter une requête",
    "Config ID": "ID de configuration",
    "Config Name": "Nom de configuration",
    "Facility Name": "Nom de l’installation",
    "Equipment Tags": "Étiquettes d’équipement",
    "Equipment ID": "ID d’équipement",
    "Facility ID": "ID d’installation",
    "Description": "Description",
    "Sampling Frequency": "Fréquence d’échantillonnage",
    "Meta": "Métadonnées",
    "ON": "Marche",
    "OFF": "Arrêt",
    "Unit": "Unité",
    "yes": "oui",
    "Yes": "Oui",
    "no": "non",
    "No": "Non",
    "Query": "Requête",
    "data": "données",
    "On Only": "Uniquement en fonctionnement",
    "Date range offset": "Décalage de plage de dates",
    "Add Time Aggregation": "Ajouter une agrégation temporelle",
    "Add Aggregation": "Ajouter une agrégation",
    "Add Series Calculation": "Ajouter un calcul de série",
    "Add Dataframe Transformation": "Ajouter une transformation de dataframe",
    "Add Filter": "Ajouter un filtre",
    "Add Series Selection": "Ajouter une sélection de série",
    "Add Series Insertion": "Ajouter une insertion de série",
    "Range offset": "Décalage de plage",
    "Offset unit": "Unité de décalage",
    "Offset amount": "Quantité de décalage",
    "Disable Offset": "Désactiver le décalage",
    "Time Aggregation": "Agrégation temporelle",
    "Frequency": "Fréquence",
    "Operation": "Opération",
    "Divide by sampling freq": "Diviser par la fréquence d’échantillonnage",
    "Horizontal Aggregation": "Agrégation horizontale",
    "Name": "Nom",
    "Insert Series": "Insérer une série",
    "Field": "Champ",
    "Value": "Valeur",
    "Series Calculation": "Calcul de série",
    "Remove Others": "Supprimer les autres",
    "Formula": "Formule",
    "Dataframe Transformation": "Transformation de dataframe",
    "Series Selection": "Sélection de série",
    "Add Series": "Ajouter une série",
    "Please select a Sensor Name or an Equipment Name": "Veuillez sélectionner un nom de capteur ou un nom d’équipement",
    "layout": "disposition",
    "Chart Type": "Type de graphique",
    "Trace Type": "Type de tracé",
    "Fill": "Remplissage",
    "Fill color": "Couleur de remplissage",
    "Y Axis": "Axe Y",
    "Stack Group": "Groupe empilé",
    "Render as Smooth Line": "Afficher en ligne lissée",
    "Min": "Min",
    "Max": "Max",
    "Color": "Couleur",
    "Custom Unit": "Unité personnalisée",
    "Opacity": "Opacité",
    "Indicator Mode": "Mode indicateur",
    "Gauge Min": "Jauge – minimum",
    "Gauge Max": "Jauge – maximum",
    "Bar color": "Couleur de la barre",
    "Border color": "Couleur de la bordure",
    "Background color": "Couleur d’arrière-plan",
    "Bar Mode": "Mode de la barre",
    "Show Scale": "Afficher l’échelle",
    "Custom Color Gradient": "Dégradé de couleur personnalisé",
    "Donut": "Anneau",
    "Box Points": "Points de boîte à moustaches",
    "Horizontal": "Horizontal",
    "Xbins Size": "Taille des bacs X",
    "Ybins Size": "Taille des bacs Y",
    "Add step": "Ajouter une étape",
    "Gauge Steps": "Étapes de jauge",
    "Title": "Titre",
    "Chart layout": "Disposition du graphique",
    "Height": "Hauteur",
    "Top Margin": "Marge supérieure",
    "Left Margin": "Marge gauche",
    "Right Margin": "Marge droite",
    "Bottom Margin": "Marge inférieure",
    "Hover Tooltip Behaviour": "Comportement de l’info-bulle au survol",
    "Show Legend": "Afficher la légende",
    "Chart Colors": "Couleurs du graphique",
    "Add Color": "Ajouter une couleur",
    "Axis settings": "Paramètres de l’axe",
    "X Axis Field": "Champ de l’axe X",
    "Independent X Series per Query": "Série X indépendante par requête",
    "X Axis Label": "Étiquette de l’axe X",
    "X Axis Format": "Format de l’axe X",
    "Y Axis Label": "Étiquette de l’axe Y",
    "Secondary Y Axis": "Axe Y secondaire",
    "Secondary Y Axis Label": "Étiquette de l’axe Y secondaire",
    "Color Axis Field": "Champ de l’axe de couleur",
    "Color Axis Scale": "Échelle de l’axe de couleur",
    "Color Axis Label": "Étiquette de l’axe de couleur",
    "3D Mode Y Axis Field": "Champ Y en mode 3D",
    "Close": "Fermer",
    "Compare X": "Comparer X",
    "Closest to pointer": "Le plus proche du pointeur",
    "Primary": "Principal",
    "Secondary": "Secondaire",
    "hour": "heure",
    "day": "jour",
    "week": "semaine",
    "month": "mois",
    "year": "année",
    "Sensor ID": "ID du capteur",
    "Type": "Type",
    "Connectors": "Connecteurs",
    "Custom View Builder": "Générateur de vue personnalisée",
    "Edit Custom View": "Modifier la vue personnalisée",
    "Default Date Range": "Plage de dates par défaut",
    "Link Title": "Titre du lien",
    "Column width": "Largeur de colonne",
    "Edit": "Modifier",
    "Duplicate": "Dupliquer",
    "Delete": "Supprimer",
    "Map": "Carte",
    "Pitch": "Inclinaison",
    "Zoom": "Zoom",
    "Center Latitude": "Latitude du centre",
    "Center Longitude": "Longitude du centre",
    "Markers": "Marqueurs",
    "Image URL": "URL de l’image",
    "Link URL": "URL du lien",
    "Latitude": "Latitude",
    "Longitude": "Longitude",
    "Add Marker": "Ajouter un marqueur",
    "OK": "OK",
    "Width": "Largeur",
    "Radius": "Rayon",
    "Blur": "Flou",
    "Max opacity": "Opacité max",
    "Player": "Lecteur",
    "Agg Frequency": "Fréquence d’agrégation",
    "Agg Operation": "Opération d’agrégation",
    "Cutoff Date": "Date limite",
    "Interpolation": "Interpolation",
    "Min X": "X min",
    "Max X": "X max",
    "Min Power": "Puissance min",
    "Max Power": "Puissance max",
    "Power Sensor": "Capteur de puissance",
    "X Sensor": "Capteur X",
    "X Title": "Titre X",
    "X Agg Operation": "Opération d’agrégation X",
    "Switch Sensor": "Capteur d’interrupteur",
    "Use Switch": "Utiliser l’interrupteur",
    "Custom Interpolation Function": "Fonction d’interpolation personnalisée",
    "Min Cooling Load": "Charge minimale de refroidissement",
    "Max Cooling Load": "Charge maximale de refroidissement",
    "COP Improvement": "Amélioration du COP",
    "Cooling Load Sensor": "Capteur de charge de refroidissement",
    "Use Filter": "Utiliser un filtre",
    "Filter Sensor": "Capteur de filtre",
    "Min Filter": "Filtre min",
    "Max Filter": "Filtre max",
    "Correlation": "Corrélation",
    "Relevant Variables": "Variables pertinentes",
    "Rule Active when Equipment On": "Règle active quand l’équipement est en marche",
    "Rule Active when Equipment Off": "Règle active quand l’équipement est arrêté",
    "Rule Active Anytime": "Règle toujours active",
    "Show Cost": "Afficher le coût",
    "X Axis Title": "Titre de l’axe X",
    "Y Axis Title": "Titre de l’axe Y",
    "Expected Value Line Name": "Nom de la courbe de valeur attendue",
    "Fitted Value Line Name": "Nom de la courbe de valeur ajustée",
    "Actual Observed Value Line Name": "Nom de la courbe de valeur observée réelle",
    "Confidence Interval Name": "Nom de l’intervalle de confiance",
    "Cooling Load Forecast": "Prévision de la charge de refroidissement",
    "Staging Profile": "Profil d’échelonnement",
    "Heatmap": "Carte thermique",
    "Fault Evaluation": "Évaluation des pannes",
    "Chiller Sequencing FLA": "Séquençage du refroidisseur FLA",
    "Chiller Sequencing Delta": "Delta de séquençage du refroidisseur",
    "Cooling Load vs OAT": "Charge de refroidissement vs température extérieure",
    "Return to Custom Views": "Revenir aux vues personnalisées",
    "Add chart": "Ajouter un graphique",
    "Add Chart": "Ajouter un graphique",
    "Save as custom view": "Enregistrer comme vue personnalisée",
    "Add Custom Chart": "Ajouter un graphique personnalisé",
    "Pie": "Camembert",
    "Bar": "Histogramme",
    "Histogram": "Histogramme",
    "Stacked Area": "Zone empilée",
    "Line": "Ligne",
    "Scatter": "Nuage de points",
    "3D Scatter": "Nuage de points 3D",
    "Scatter with Color Scale": "Nuage de points avec échelle de couleur",
    "Optimization": "Optimisation",
    "View All": "Afficher tout",
    "Changes Saved": "Modifications enregistrées",
    "Are you sure you want to delete this connector?": "Êtes-vous sûr de vouloir supprimer ce connecteur ?",
    "New Simple View": "Nouvelle vue simple",
    "New Advanced View": "Nouvelle vue avancée",
    "Import JSON": "Importer JSON",
    "Import Preset": "Importer un préréglage",
    "Import Local Plots": "Importer des graphiques locaux",
    "Import custom view from JSON": "Importer une vue personnalisée depuis un JSON",
    "Import": "Importer",
    "Publish": "Publier",
    "Un-Publish": "Annuler la publication",
    "Export": "Exporter",
    "Facility": "Installation",
    "Published": "Publié",
    "Top-level Link": "Lien de premier niveau",
    "Link position": "Position du lien",
    "Menu Folder": "Dossier du menu",
    "Are you sure you want to delete this view?": "Êtes-vous sûr de vouloir supprimer cette vue ?",
    "View Deleted": "Vue supprimée",
    "Custom view saved": "Vue personnalisée enregistrée",
    "Are you sure you want to upload all local plots to your user account?": "Êtes-vous sûr de vouloir téléverser tous les graphiques locaux sur votre compte utilisateur ?",
    "Views Imported": "Vues importées",
    "A custom view with this ID already exists. Are you sure you want to override it ?": "Une vue personnalisée avec cet ID existe déjà. Êtes-vous sûr de vouloir l’écraser ?",
    "End date": "Date de fin",
    "Dynamic Control": "Contrôle dynamique",
    "Software Switches": "Interrupteurs logiciels",
    "Control Readings": "Lectures de contrôle",
    "Sensor Readings": "Lectures du capteur",
    "Point Name": "Nom du point",
    "Status": "Statut",
    "Error": "Erreur",
    "Equipment plots": "Graphiques de l’équipement",
    "Equipment name": "Nom de l’équipement",
    "Start date": "Date de début",
    "Floor name": "Nom de l’étage",
    "Equipment Summary": "Résumé de l’équipement",
    "Display equipment plots": "Afficher les graphiques de l’équipement",
    "Display anomalies": "Afficher les anomalies",
    "Data Export": "Exportation des données",
    "View Data": "Afficher les données",
    "Download CSV": "Télécharger le CSV",
    "Time Agg Frequency": "Fréquence d’agrégation temporelle",
    "Time Agg Operation": "Opération d’agrégation temporelle",
    "Return data as": "Retourner les données au format",
    "Series name": "Nom de la série",
    "Change Password": "Modifier le mot de passe",
    "User ID": "ID d’utilisateur",
    "Your password has not been changed in over 3 months. Please consider updating it for security.": "Votre mot de passe n'a pas été modifié depuis plus de 3 mois. Veuillez envisager de le mettre à jour pour des raisons de sécurité.",
    "Update On": "Mis à jour le",
    "Created On": "Créé le",
    "Role": "Rôle",
    "Users": "Utilisateurs",
    "Dashboard Setup": "Configuration du tableau de bord",
    "Not logged in as administrator": "Non connecté en tant qu’administrateur",
    "Log Out": "Déconnexion",
    "Dashboard setup complete": "Configuration du tableau de bord terminée",
    "Back to Home": "Retour à l’accueil",
    "Current Logged In User": "Utilisateur actuellement connecté",
    "Facility and Points": "Installation et points",
    "Current Facility": "Installation actuelle",
    "Equipment List and Points": "Liste des équipements et points",
    "used": "utilisé",
    "licensed": "sous licence",
    "Setting": "Paramètre",
    "sample": "échantillon",
    "samples": "échantillons",
    "every hour": "toutes les heures",
    "Currency and Energy Pricing": "Monnaie et prix de l’énergie",
    "per kWh": "par kWh",
    "Points List": "Liste des points",
    "Energy Price": "Prix de l’énergie",
    "Equipment On": "Équipement en marche",
    "Equipment Off": "Équipement arrêté",
    "Anytime": "N’importe quand",
    "Active": "Actif",
    "Inactive": "Inactif",
    "Muted": "En sourdine",
    "Muted by": "Mis en sourdine par",
    "Muted date": "Date de mise en sourdine",
    "Mute": "Mettre en sourdine",
    "Un-Mute": "Réactiver",
    "Applicable Group(s)": "Groupe(s) concerné(s)",
    "Rule Active when": "Règle active lorsque",
    "Active Status": "Statut actif",
    "Reports": "Rapports",
    "Test Message": "Message de test",
    "Severity Level(s)": "Niveau(x) de gravité",
    "Distribution List": "Liste de distribution",
    "Power Prediction": "Prévision de puissance",
    "Parameter Name": "Nom du paramètre",
    "Parameter Value": "Valeur du paramètre",
    "Parameter Value Str": "Valeur de paramètre (texte)",
    "Parameter Description": "Description du paramètre",
    "Graphical View": "Vue graphique",
    "Model": "Modèle",
    "Add Model": "Ajouter un modèle",
    "Model Name": "Nom du modèle",
    "Model Type": "Type de modèle",
    "Job": "Tâche",
    "Add Job": "Ajouter une tâche",
    "New Job": "Nouvelle tâche",
    "No Result Yet": "Aucun résultat pour le moment",
    "Reset all result": "Réinitialiser tous les résultats",
    "Reset all result will delete all result and rerun with latest setting.": "Réinitialiser tous les résultats supprimera toutes les données et relancera le processus avec les derniers paramètres.",
    "Train Comp Power Model": "Entraîner le modèle de puissance du compresseur",
    "This will retrain the Comp Power Model": "Cela entraînera à nouveau le modèle de puissance du compresseur",
    "Ack Old Notifications": "Reconnaître les anciennes notifications",
    "Ack Old Notifications older than the following threshold or 30 days if no threshold is mentioned.": "Reconnaître les notifications plus anciennes que le seuil ci-dessous ou de 30 jours si aucun seuil n’est mentionné.",
    "End date threshold": "Seuil de date de fin",
    "Job ID": "ID de la tâche",
    "Carnot Innovations Terms of Service": "Conditions d’utilisation de Carnot Innovations",
    "Critical": "Critique",
    "Download with Maintenance": "Télécharger (maintenance incluse)",
    "Severity filter": "Filtre de gravité",
    "Notification ID": "ID de notification",
    "Occurred Times": "Nombre d’occurrences",
    "Focus Range": "Plage de focus",
    "Location": "Emplacement",
    "Start Time": "Heure de début",
    "End Time": "Heure de fin",
    "Comments": "Commentaires",
    "Actions Taken": "Actions entreprises",
    "Reported by": "Signalé par",
    "Report date": "Date du rapport",
    "Certified by": "Certifié par",
    "Certified date": "Date de certification",
    "Endorsed by": "Approuvé par",
    "Endorsed date": "Date d’approbation",
    "Menu List": "Liste du menu",
    "New Folder Name": "Nouveau nom de dossier",
    "Available Views": "Vues disponibles",
    "Edit Folder Name": "Modifier le nom du dossier",
    "Edit Custom View Display": "Modifier l’affichage de la vue personnalisée",
    "Custom View Name": "Nom de la vue personnalisée",
    "Icon": "Icône",
    "Folder cannot be nested!": "Le dossier ne peut pas être imbriqué !",
    "Folder name must be unique.": "Le nom du dossier doit être unique.",
    "Add Anomaly Description": "Ajouter une description d’anomalie",
    "Relevant variable": "Variable pertinente",
    "Equipment Regex": "Expression régulière pour l’équipement",
    "Time Delay": "Délai",
    "Open diagnostics view": "Ouvrir la vue de diagnostic",
    "timestamp": "horodatage",
    "Top 10 overall anomaly scores": "Top 10 des scores d’anomalies globales",
    "File must be selected.": "Un fichier doit être sélectionné.",
    "Exactly 1 file must be provided.": "Un seul fichier doit être fourni.",
    "Done": "Terminé",
    "Please select 1 file to upload.": "Veuillez sélectionner 1 fichier à téléverser.",
    "Please wait ... It will take up to a minute.": "Veuillez patienter… Cela peut prendre jusqu’à une minute.",
    "Upload Completed.": "Téléversement terminé.",
    "Fail.  Please Retry.": "Échec. Veuillez réessayer.",
    "Add Tag": "Ajouter une étiquette",
    "Connector": "Connecteur",
    "Add Points": "Ajouter des points",
    "Point Selector": "Sélecteur de points",
    "Available points": "Points disponibles",
    "Show filters": "Afficher les filtres",
    "Hide filters": "Masquer les filtres",
    "Selected points": "Points sélectionnés",
    "Clear selection": "Effacer la sélection",
    "Add selected points": "Ajouter les points sélectionnés",
    "Total energy consumption (kWh)": "Consommation totale d’énergie (kWh)",
    "Energy Savings": "Économies d’énergie",
    "Add Dates": "Ajouter des dates",
    "Add Equipment Servicing Schedule": "Ajouter un calendrier de maintenance d’équipement",
    "Applies to": "S’applique à",
    "Entire Site": "Site entier",
    "Floor Name": "Nom de l’étage",
    "View": "Vue",
    "Apply changes": "Appliquer les modifications",
    "Save whiteboard": "Enregistrer le tableau blanc",
    "Edit all notes": "Modifier toutes les notes",
    "Add Stickie to board": "Ajouter un post-it au tableau",
    "Add Photo / Graphics to board": "Ajouter une photo/graphique au tableau",
    "Add Board": "Ajouter un tableau",
    "Board Name": "Nom du tableau",
    "Double Click to select an image.": "Double-cliquez pour sélectionner une image.",
    "Edit this Stickie": "Modifier ce post-it",
    "Delete this Stickie": "Supprimer ce post-it",
    "Edit Image": "Modifier l’image",
    "Edit Label": "Modifier l’étiquette",
    "Label": "Étiquette",
    "Label Only": "Uniquement étiquette",
    "Font size": "Taille de la police",
    "Font color": "Couleur de la police",
    "Variable": "Variable",
    "Microsoft authentication anomaly. Please renew login.": "Anomalie d’authentification Microsoft. Veuillez renouveler la connexion.",
    "Change Backend URL": "Changer l’URL du backend",
    "Target URL": "URL cible",
    "Setting URL.  Please wait.": "Configuration de l’URL. Veuillez patienter.",
    "Set": "Définir",
    "Model ID": "ID du modèle",
    "Target Equipment": "Équipement cible",
    "Model Selection": "Sélection de modèle",
    "Model Message": "Message du modèle",
    "Training Data Date Range": "Plage de dates des données d’entraînement",
    "Severity Levels": "Niveaux de gravité",
    "Phone number": "Numéro de téléphone",
    "Message": "Message",
    "Send": "Envoyer",
    "Active - rule will be applied": "Actif – la règle sera appliquée",
    "Inactive - rule will not run": "Inactif – la règle ne s’exécutera pas",
    "Muted - rules will be applied, but notifications (if any) will immediately be acknowledged": "En sourdine – les règles seront exécutées, mais les notifications (le cas échéant) seront immédiatement reconnues",
    "Used parameters": "Paramètres utilisés",
    "Recommended Action": "Action recommandée",
    "Run test": "Exécuter le test",
    "Test the rule": "Tester la règle",
    "Validation succeeded!": "Validation réussie !",
    "Password not matched / Password cannot be empty": "Le mot de passe ne correspond pas / Le mot de passe ne peut pas être vide",
    "Password is too common. Please choose a more unique password.": "Le mot de passe est trop courant. Veuillez choisir un mot de passe plus unique.",
    "Password should not contain personal information or username.": "Le mot de passe ne doit pas contenir d'informations personnelles ou le nom d'utilisateur.",
    "Password should not contain common dictionary words.": "Le mot de passe ne doit pas contenir de mots courants du dictionnaire.",
    "Password should not contain sequential characters (e.g., 1234, abcd).": "Le mot de passe ne doit pas contenir de caractères séquentiels (par ex., 1234, abcd).",
    "Password does not meet minimum complexity requirements.": "Le mot de passe ne répond pas aux exigences minimales de complexité.",
    "Password does not meet security requirements.": "Le mot de passe ne répond pas aux exigences de sécurité.",
    "Password must be unique, complex, and avoid common words or personal information. Avoid easily guessed passwords like \"Password1234\" or \"Las Vegas\".": "Le mot de passe doit être unique, complexe et éviter les mots courants ou les informations personnelles. Évitez les mots de passe facilement devinables comme \"Password1234\" ou \"Las Vegas\".",
    "Confirm New Password": "Confirmez le nouveau mot de passe",
    "New Password": "Nouveau mot de passe",
    "uppercase letters": "lettres majuscules",
    "lowercase letters": "lettres minuscules",
    "numbers": "chiffres",
    "special characters": "caractères spéciaux",
    "unicode characters": "caractères Unicode",
    "Password must contain at least 4 different character types (uppercase, lowercase, numbers, special characters, unicode)": "Le mot de passe doit contenir au moins 4 types de caractères différents (majuscules, minuscules, chiffres, caractères spéciaux, Unicode)",
    "Administrator": "Administrateur",
    "Maintainer": "Mainteneur",
    "Operator": "Opérateur",
    "Updated On": "Mis à jour le",
    "Authorized Facilities": "Installations autorisées",
    "User Account": "Compte utilisateur",
    "Monthly Summary Energy/Faults": "Résumé mensuel Énergie/Pannes",
    "Monthly Summary: Chiller Plant": "Résumé mensuel : Installation de refroidissement",
    "Chiller Staging": "Échelonnement du refroidisseur",
    "Edit Maintenance Record": "Modifier l’enregistrement de maintenance",
    "Builder": "Générateur",
    "Equipment Group": "Groupe d’équipement",
    "FDD Breakdown": "Détail FDD",
    "Cluster View": "Vue en cluster",
    "Get link": "Obtenir le lien",
    "Chiller Plant Overview": "Aperçu de l’installation de refroidissement",
    "General - CHW_Header Leaving and Entering Temp": "Général – Temp. de sortie et d’entrée du collecteur d’eau glacée (CHW)",
    "General - CHW_Header DP vs OAT": "Général – DP du collecteur d’eau glacée (CHW) vs temp. extérieure",
    "Advanced - Cooling Load and Power Over Time": "Avancé – Charge de refroidissement et puissance au fil du temps",
    "Advanced - CHW_Header Depth Analysis": "Avancé – Analyse approfondie du collecteur d’eau glacée (CHW)",
    "Cooling Load Prediction": "Prévision de la charge de refroidissement",
    "Last 10 Days Cooling Load Prediction": "Prévision de la charge de refroidissement sur les 10 derniers jours",
    "Hide Date": "Masquer la date",
    "Monthly": "Mensuel",
    "Month Range": "Plage mensuelle",
    "On Only Switch": "Uniquement lorsque l’interrupteur est sur marche",
    "Equip Select": "Sélection de l’équipement",
    "Equipment Type filter": "Filtre par type d’équipement",
    "Equipment Floor filter": "Filtre par étage d’équipement",
    "Min Width": "Largeur min",
    "Borders": "Bordures",
    "Restricted Access": "Accès restreint",
    "Namespace": "Espace de noms",
    "Hide Controls": "Masquer les contrôles",
    "Menu Config": "Configuration du menu",
    "Save As": "Enregistrer sous",
    "Add Component": "Ajouter un composant",
    "Rich Text": "Texte enrichi",
    "Notification Facet": "Facette de notification",
    "3D Viewer": "Visionneuse 3D",
    "3D Heatmap": "Carte thermique 3D",
    "Custom Optimization": "Optimisation personnalisée",
    "Custom COP Savings": "Économies de COP personnalisées",
    "Custom": "Personnalisé",
    "HTML Code": "Code HTML",
    "Custom EC": "EC personnalisé",
    "Animation": "Animation",
    "Enable Merge": "Activer le regroupement",
    "Animation timer (seconds)": "Durée de l’animation (secondes)",
    "Maintenance Summary": "Résumé de maintenance",
    "Issue Summary": "Résumé du problème",
    "Grahic": "Graphique",
    "FDD Report": "Rapport FDD",
    "Cost Breakdown": "Répartition des coûts",
    "Sensor Cailbration": "Étalonnage du capteur",
    "Energy Breakdown": "Répartition de l’énergie",
    "Solar": "Solaire",
    "Main light intensity": "Intensité lumineuse principale",
    "Ambient light intensity": "Intensité lumineuse ambiante",
    "Show Clock": "Afficher l’horloge",
    "Parameters": "Paramètres",
    "Autotuner": "Auto-régleur",
    "Actual Observed Value": "Valeur observée réelle",
    "Fitted Value": "Valeur ajustée",
    "Expected Value": "Valeur attendue",
    "Insert at": "Insérer à",
    "Air-side": "Côté air",
    "Air-side Overview": "Aperçu côté air",
    "Air-side CO2 Overtime": "CO₂ côté air sur la durée",
    "AHU Temp and VFD Over Time": "Temp. UTA et VFD sur la durée",
    "Download plot as a png": "Télécharger le graphique au format PNG",
    "Zoom in": "Zoomer",
    "Zoom out": "Dézoomer",
    "Autoscale": "Auto-échelle",
    "Reset axes": "Réinitialiser les axes",
    "Pan": "Panoramique",
    "Toggle Spike Lines": "Basculer les lignes de repère",
    "Show closest data on hover": "Afficher les données les plus proches au survol",
    "Compare data on hover": "Comparer les données au survol",
    "Produced with Plotly": "Réalisé avec Plotly",
    "Rows per page": "Lignes par page",
    "Maintenance ID": "ID de maintenance",
    "View points when equipment is On": "Afficher les points lorsque l’équipement est actif",
    "Reassign user for all maintenance records": "Réassigner un utilisateur pour tous les enregistrements de maintenance",
    "Mass Reassign": "Réassignation de masse",
    "Currently assigned to": "Actuellement assigné à",
    "Reassign to": "Réassigner à",
    "Reassign": "Réassigner",
    "View Diff": "Afficher la différence",
    "Diff mode": "Mode de différence",
    "Select file": "Sélectionner un fichier",
    "Choose File": "Choisir un fichier",
    "Convert categorical to numeric": "Convertir les données catégorielles en numériques",
    "Resampling": "Rééchantillonnage",
    "Matching": "Appariement",
    "Data Upload": "Téléversement de données",
    "Toggle Connectors": "Basculer les connecteurs",
    "Graphic": "Graphique",
    "Equipment Relationships": "Relations entre équipements",
    "Equipment1": "Équipement1",
    "Equipment2": "Équipement2",
    "Graph view": "Vue graphique",
    "List view": "Vue liste",
    "Relationships type": "Type de relations",
    "Equipment Relationships Upload": "Téléversement des relations d’équipement",
    "Point Mapping": "Cartographie des points",
    "Point Mapper": "Mappeur de points",
    "Mass Update": "Mise à jour de masse",
    "Split Paths": "Fractionner les chemins",
    "Map Points": "Cartographier les points",
    "Get Suggestions": "Obtenir des suggestions",
    "Suggestions": "Suggestions",
    "Units": "Unités",
    "Delete Table": "Supprimer le tableau",
    "id": "id",
    "path": "chemin",
    "carnot_name": "nom_carnot",
    "point": "point",
    "equip": "équipement",
    "equip_type": "type_d’équipement",
    "floor": "étage",
    "tower": "",
    "unit": "unité",
    "actions": "actions",
    "No data available": "Aucune donnée disponible",
    "Discovered Points": "Points découverts",
    "upstream_id": "id en amont",
    "upstream_sensor_name": "nom du capteur en amont",
    "site": "site",
    "sensor_name": "nom du capteur",
    "sensor_desc": "description du capteur",
    "meta": "métadonnées",
    "equip_meta": "métadonnées d’équipement",
    "Unmapped Only": "Uniquement non cartographiés",
    "Scripts": "Scripts",
    "Script": "Script",
    "Version": "Version",
    "Updated": "Mis à jour",
    "Optimization Controls": "Contrôles d’optimisation",
    "Current Value": "Valeur actuelle",
    "Write": "Écrire",
    "Priority": "Priorité",
    "Graphics": "Graphiques",
    "Dashboard": "Tableau de bord",
    "Build time": "Temps de compilation",
    "Coordinated Universal Time": "Temps universel coordonné",
    "Rule Creation": "Création de règle",
    "Auto-diagnose": "Auto-diagnostic",
    "This will disable all rules which lack the required variables. Are you sure you want to run auto-diagnostic?": "Cela désactivera toutes les règles qui n’ont pas les variables requises. Êtes-vous sûr de vouloir exécuter l’auto-diagnostic ?",
    "KPI Thresholds": "Seuils KPI",
    "Custom view": "Vue personnalisée",
    "New Link Name": "Nouveau nom de lien",
    "Show Recent Notifications Only": "Afficher uniquement les notifications récentes",
    "Apply": "Appliquer",
    "3D Model link": "Lien du modèle 3D",
    "Close testing interface": "Fermer l’interface de test",
    "Component Titles": "Titres des composants",
    "Last Updated": "Dernière mise à jour",
    "Add components": "Ajouter des composants",
    "Toggle sensor picker": "Basculer le sélecteur de capteurs",
    "Toggle debug mode": "Basculer en mode débogage",
    "Time aggregation": "Agrégation temporelle",
    "Latest Only": "Derniers uniquement",
    "Custom date range": "Plage de dates personnalisée",
    "Presents": "Présentations",
    "Summary": "Résumé",
    "Bar - group": "Barres – groupe",
    "Bar - stack": "Barres – empilées",
    "Bar summary": "Résumé en barres",
    "Gauge": "Jauge",
    "Number": "Nombre",
    "Layout": "Disposition",
    "Legend Position": "Position de la légende",
    "Colors": "Couleurs",
    "Limit X Axis Ticks": "Limiter le nombre de graduations sur l’axe X",
    "Y Axis Format": "Format de l’axe Y",
    "Y Axis Custom Range": "Plage personnalisée de l’axe Y",
    "Marker Size Field": "Champ de taille du marqueur",
    "Color Axis Custom Range": "Plage personnalisée de l’axe de couleur",
    "Annotations": "Annotations",
    "Text": "Texte",
    "Returned series": "Séries retournées",
    "Add Series Insertion by Ref": "Ajouter l’insertion de série par référence",
    "Add Calendar Insertion": "Ajouter une insertion de calendrier",
    "Add Conversion to enum": "Ajouter une conversion en énumération",
    "Number Size": "Taille du nombre",
    "Number Format": "Format du nombre",
    "Create a writable connector to add writable points": "Créer un connecteur écrivable pour ajouter des points écrivables",
    "Generate API Token": "Générer un jeton API",
    "Username": "Nom d'utilisateur",
    "Two Factor Code": "Code à deux facteurs",
    "Your API token has been generated. Copy and store it securely:": "Votre jeton API a été généré. Copiez-le et stockez-le en sécurité :",
    "API Token": "Jeton API",
    "This token has a long expiration and can be used for API authentication. Keep it secure and do not share it.": "Ce jeton a une longue expiration et peut être utilisé pour l'authentification API. Gardez-le sécurisé et ne le partagez pas.",
    "Generate Token": "Générer un jeton",
    "Token copied to clipboard": "Jeton copié dans le presse-papiers",
    " assigned this to ": " a assigné ceci à ",
    " fixed this": " a corrigé ceci",
    " matching notifications?": " notifications correspondantes ?",
    " required fixing": " nécessitait une correction",
    "Adjustment Frequency": "Fréquence d'ajustement",
    "An error occurred while generating the token.": "Une erreur s'est produite lors de la génération du jeton.",
    "Are you sure you want mark ": "Êtes-vous sûr de vouloir marquer ",
    "Are you sure you want to ack all ": "Êtes-vous sûr de vouloir accuser réception de toutes ",
    "Are you sure you want to delete this equipment?. The deletion process is asynchronous. You can use the dashboard as usual while it runs in the background.": "Êtes-vous sûr de vouloir supprimer cet équipement ? Le processus de suppression est asynchrone. Vous pouvez utiliser le tableau de bord normalement pendant qu'il s'exécute en arrière-plan.",
    "Are you sure you want to delete this model?": "Êtes-vous sûr de vouloir supprimer ce modèle ?",
    "Are you sure you want to recalculate data for this calculated point?": "Êtes-vous sûr de vouloir recalculer les données pour ce point calculé ?",
    "Are you sure you want to reset the authenticator for this user?": "Êtes-vous sûr de vouloir réinitialiser l'authentificateur pour cet utilisateur ?",
    "Are you sure you want to retrain this model?": "Êtes-vous sûr de vouloir réentraîner ce modèle ?",
    "Are you sure you want to unack all ": "Êtes-vous sûr de vouloir annuler la réception de toutes ",
    "Async job requested": "Tâche asynchrone demandée",
    "Calculation Statement": "Instruction de calcul",
    "Changes saved": "Modifications enregistrées",
    "Compare Y": "Comparer Y",
    "Component coped to clipboard": "Composant copié dans le presse-papiers",
    "Component copied to clipboard": "Composant copié dans le presse-papiers",
    "Counts": "Comptages",
    "custom month": "mois personnalisé",
    "Custom view copied to clipboard": "Vue personnalisée copiée dans le presse-papiers",
    "Custom view too big. Size cannot exceed 5MB.": "Vue personnalisée trop grande. La taille ne peut pas dépasser 5 Mo.",
    "Data copied to clipboard": "Données copiées dans le presse-papiers",
    "data preview": "aperçu des données",
    "Data uploaded": "Données téléchargées",
    "Date": "Date",
    "Discovery requested": "Découverte demandée",
    "Discovery Requested": "Découverte demandée",
    "Done. Equipment relationships created: ": "Terminé. Relations d'équipement créées : ",
    "Done. Points created: ": "Terminé. Points créés : ",
    "Done. Recalculation jobs created: ": "Terminé. Tâches de recalcul créées : ",
    "Equipment 1": "Équipement 1",
    "Equipment 2": "Équipement 2",
    "Event saved": "Événement enregistré",
    "Extra Sensors": "Capteurs supplémentaires",
    "Flatline": "Valeur constante",
    "Full query copied to clipboard": "Requête complète copiée dans le presse-papiers",
    "History re-import job requested": "Tâche de réimportation de l'historique demandée",
    "Import complete": "Importation terminée",
    "Invalid view JSON.": "JSON de vue invalide.",
    "Issues": "Problèmes",
    "Last 7 Days": "7 derniers jours",
    "License maintenance is out of date.": "La maintenance de la licence est périmée.",
    "License point limit exceeded. Data collection stopped.": "Limite de points de licence dépassée. La collecte de données a été arrêtée.",
    "Login failed. Please check your credentials.": "Échec de la connexion. Veuillez vérifier vos informations d'identification.",
    "Maintenance": "Maintenance",
    "Maintenance records": "Enregistrements de maintenance",
    "Mapping config copied to clipboard": "Configuration de mappage copiée dans le presse-papiers",
    "Missing Critical Sensors": "Capteurs critiques manquants",
    "Missing Important Sensors": "Capteurs importants manquants",
    "Missing Optional Sensors": "Capteurs optionnels manquants",
    "Missing Sensors": "Capteurs manquants",
    "month end": "fin du mois",
    "month start": "début du mois",
    "Name must be unique.": "Le nom doit être unique.",
    "No calculated points found for this name": "Aucun point calculé trouvé pour ce nom",
    "No missing sensors detected": "Aucun capteur manquant détecté",
    "Note on": "Note sur",
    "Occurrences": "Occurrences",
    "Out of range Counts": "Comptages hors plage",
    "Owner": "Propriétaire",
    "Password cannot be empty": "Le mot de passe ne peut pas être vide",
    "Password must be a valid string": "Le mot de passe doit être une chaîne valide",
    "Password must be at least ": "Le mot de passe doit comporter au moins ",
    "Password must be unique, complex, and avoid common words or personal information. Avoid easily guessed passwords like ": "Le mot de passe doit être unique, complexe et éviter les mots courants ou les informations personnelles. Évitez les mots de passe faciles à deviner comme ",
    "Password must contain at least ": "Le mot de passe doit contenir au moins ",
    "Password not matched": "Le mot de passe ne correspond pas",
    "Please select an equipment": "Veuillez sélectionner un équipement",
    "Points already exists for: ": "Les points existent déjà pour : ",
    "Points could not be created for: ": "Les points n'ont pas pu être créés pour : ",
    "Points edited: ": "Points modifiés : ",
    "Progress": "Progression",
    "Query item copied to clipboard": "Élément de requête copié dans le presse-papiers",
    "Reassigned ": "Réassigné ",
    "Recalculation job requested": "Tâche de recalcul demandée",
    "Recommended Actions:": "Actions recommandées :",
    "Requested point mapping vendor not found": "Fournisseur de mappage de points demandé introuvable",
    "Site": "Site",
    "Sync complete": "Synchronisation terminée",
    "Target": "Cible",
    "Thank you for your feedback!": "Merci pour votre retour !",
    "This will apply the chart preset and override any custom code. Are you sure you want to proceed?": "Ceci appliquera le préréglage du graphique et remplacera tout code personnalisé. Êtes-vous sûr de vouloir continuer ?",
    "to sampling freq": "à la fréquence d'échantillonnage",
    "Two-factor authentication required": "Authentification à deux facteurs requise",
    "Update request sent": "Demande de mise à jour envoyée",
    "View Exported": "Vue exportée",
    "Viewer": "Visualiseur",
    "year end": "fin d'année",
    "year start": "début d'année"
}